import React from 'react';
import { Popover } from '../Popover';

export const DropdownPopover = ({
  options = [],
  offset = 0,
  open = false,
  value,
  children,
  renderOptions,
  placement,
}) => {
  const resolveSelectedOption = () => options.find((option) => option.value === value) || undefined;

  const renderChildren = ({ ref, open }) => {
    if (typeof children === 'function') {
      const selectedOption = resolveSelectedOption();
      return children({ selectedOption, ref, open });
    }
    return children;
  };

  return (
    <Popover
      placement={placement}
      offset={offset}
      open={open}
      render={({ close }) => renderOptions({ options, value, close })}
    >
      {({ open, ...rest }) => (
        <div style={{ cursor: 'pointers', display: 'inline-block' }} {...rest}>
          {renderChildren({ open })}
        </div>
      )}
    </Popover>
  );
};
